<template>
  <div class="card-content">
    <div class="signin-form row justify-content-center p-0 m-0">
      <form class="form-group pl-3 pr-3 mt-auto mb-4" @submit.prevent="signin">
        <div class="mb-5 mt-5">
          <h3 class="m-0">Bem vindo ao</h3>
          <h1 class="m-0"><big>Atendimento e Suporte</big></h1>
        </div>
        <div class="mb-3" :class="{'has-error': usernameIsInvalid, '': !passwordIsInvalid}">
          <label class="mb-2">E-mail:</label>
          <input class="form-control text-center" id="username" type="text" autofocus v-model="username" @input="$v.username.$touch()">
          <small class="text-danger" v-if="usernameIsInvalid">E-mail inválido.</small>
        </div>
        <div class="mb-4" :class="{'has-error': passwordIsInvalid, '': !passwordIsInvalid }">
          <label class="mb-2">Senha:</label>
          <input class="form-control text-center" id="password" type="password" v-model="password" @input="$v.password.$touch()">
          <small class="text-danger" v-if="passwordIsInvalid">Senha obrigatória.</small>
        </div>
        <div class="mb-4">
          <vue-recaptcha loadRecaptchaScript ref=" recaptcha" :sitekey="recaptcha.siteKey" @verify="onVerify($event)"
            @expired="onExpired">
          </vue-recaptcha>
          <small class="text-danger" v-if="this.$v.recaptcha.$dirty && !recaptcha.token">
            <b>* reCaptcha é obrigatória.</b>
          </small>
        </div>
        <div class="text-center mb-4">
          <button class="btn btn-primary btn-pill col-sm-12 col-md-5 mt-3 mb-3" type="submit">
          Entrar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AccountApi from '@/services/AccountApi'
import AppAlert from '@/components/theme/Alert'
import AppSpinner from '@/components/theme/Spinner'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Signin',
  data () {
    return {
      title: 'Sign in Help Desk',
      username: null,
      password: null,
      recaptcha: {
        siteKey: `${process.env.SITE_KEY_RECAPTCHA}`,
        token: null
      }
    }
  },
  methods: {
    onVerify (token) {
      this.recaptcha.token = token
    },
    onExpired () {
      this.recaptcha.token = null
    },
    async signin () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      if (!this.recaptcha.token) {
        this.$v.recaptcha.$touch()
        return
      }

      const api = new AccountApi()
      this.$bus.$emit('spinner-run')
      const response = await api.signin(this.username, this.password)
      if (response.status === 401) {
        this.$bus.$emit('spinner-stop')
        this.$alert.error('Ops', 'E-mail e/ou senha estão inválidos.')
        return
      }
      this.$bus.$emit('spinner-stop')
      this.auth(response.data)
      this.$router.push('/')
    },
    ...mapActions({
      auth: 'account/login'
    })
  },
  validations: {
    username: {
      required,
      email
    },
    password: {
      required
    },
    recaptcha: {
      required
    }
  },
  computed: {
    usernameIsInvalid () {
      return this.$v.username.$invalid && this.$v.username.$dirty
    },
    passwordIsInvalid () {
      return this.$v.password.$invalid && this.$v.password.$dirty
    }
  },
  components: {
    AppSpinner,
    AppAlert,
    VueRecaptcha
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/Signin.vue